/**
 * Helper function to check if the dark mode is enabled
 * @returns Boolean
 */
export const checkDarkMode = (): boolean => {
  return localStorage.getItem('theme-dark-mode') === 'true';
};
